class PartnersSlider {
	constructor($el) {
		this.$el = $el;


		let ActiveWrapAround = true;
		let groupCells = false;

		if (document.body.clientWidth >= 1183) {
			if (this.$el[0].children.length <= 4) {
				ActiveWrapAround = false;
				groupCells = this.$el[0].children.length;
			}
		} else if (this.$el[0].children.length <= 3 && document.body.clientWidth >= 450) {
			ActiveWrapAround = false;
			groupCells = this.$el[0].children.length;
		} else if (this.$el[0].children.length <= 2) {
			ActiveWrapAround = false;
			groupCells = this.$el[0].children.length;
		}

		this.options = {
			groupCells: groupCells,
			autoPlay: true,
			pageDots: false,
			wrapAround: ActiveWrapAround,
			prevNextButtons: false,
			freeScroll: true,
			cellSelector: ".partenaires__list__item",
			cellAlign: "center",
			imagesLoaded: true
		};


		if (this.$el.length) {
			this._createSlider();
		}
	}

	_createSlider() {
		this.$el.flickity(this.options);
	}
}

export default PartnersSlider;